LoginServices.$inject = ["$resource"];

function LoginServices($resource) {
  return $resource(`${apiSecurity}/:type/:id/:routeParams/:routeParams2`, {
    id: '@id',
    type: '@type',
    routeParams: '@routeParams',
    routeParams2: '@routeParams2'
  }, {
    query: {
      method: "GET",
      isArray: true
    },

    create: {
      method: "POST"
      // headers: {
      //     "Content-Type": "application/x-www-form-urlencoded"
      // }
    },

    get: {
      method: "GET"
    },

    getLogo: { method: "get", url: `${apiGetWay}/:type/:id/:routeParams`},
    getAuthorizationInfo: {
      method: "get",
      url: `${gateway}/authorization/v1/users/:id/authorization-info`
    },

    remove: {
      method: "DELETE"
    },

    update: {
      method: "PUT"
    }
  }
  );
}

module.exports = ngModule => {
  ngModule.factory("LoginServices", LoginServices);
};
